<script>
import formatCurrency from "@utils/format-currency";
import formatPrice from "@utils/format-price";
import { prepaidFormatExpiredDate, prepaidFormatUsedTimes } from "@utils/ipetbooking-prepaid";
import { conditionList } from "@utils/is-condition";
import { authComputed, merchantComputed } from '@store/helpers'
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";
import {
  orderIsPrepaidUnpaidAndDeduct,
  orderBillingReservationList,
} from "@utils/ipetbooking-order";

export default {
  name:'InfoBox4',
  props: {
    cart: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isUnpaid: {
      type: Boolean,
      default: false
    },
    formatSubmitText: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    submitData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isActive: 0
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.orderItem })
    },
    billList() {
      if(this.isUnpaid) {
        return orderBillingReservationList({
          type: 'memberOrder',
          ...this.cart,
          priceTotal: this.cart.price,
          isUnpaidAndDeduct: this.isUnpaidAndDeduct
        });
      } else {

        return conditionList([
          {
            title: `1<i class="fontello ${this.$globalIsDingBeauty ? 'fontello-db-lipstick fs-lg' : 'fontello-paw'} fa-fw ml-2 text-primary"></i>`,
            text: `${
                  this.cart.prepaid.levelDiscount > 0 ? 
                  `<span class="">
                    會員價：NT$ ${formatCurrency(memberLevelPriceDiscount(this.cart.prepaid.price, this.cart.prepaid))}
                  </span>
                  <br>
                  <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：${formatCurrency(this.cart.prepaid.price)}</span>`
                  : `NT$ ${formatCurrency(this.cart.prepaid.price)}`
                }`,
            textClass: 'font-number'
          },
          {
            title: `折扣${this.cart.discountValue}${this.cart.discountType === '%' ? '%' : ''}`,
            text: `-NT$ ${formatCurrency(this.cart.discountAmount)}`,
            class: 'text-danger',
            textClass: 'font-number',
            condition: () => {
              return !!this.isUnpaid && !!this.cart.discountAmount && !!this.cart.discountType && !!this.cart.discountValue
            },
          },
          // {
          //   type: 'hr'
          // },
          // {
          //   title: '總計',
          //   text: formatPrice(total),
          //   class: 'align-items-end',
          //   textClass: 'text-primary-dark font-number fw-semi-bold fs-xl'
          // },
        ])
      }
    },
    sizeTitle() {
      return this.cart.prepaid.applicableEvents[0].sizeTitle
    },
    categoryTitle() {
      return this.cart.prepaid.applicableEvents[0].categoryTitle
    },
    cartTotal() {
      return this.isUnpaid
        ? memberLevelPriceDiscount(this.cart.price, this.cart)
        : memberLevelPriceDiscount(this.cart.prepaid.total, this.cart.prepaid)
    }
  },
  methods: {
    prepaidFormatExpiredDate,
    prepaidFormatUsedTimes,
    formatPrice,
    isShow(index) {
      this.isActive = index
    },
    onBeforeEnter(el) {
      el.style.display = 0;
      el.style.height = 0;
    },
    onEnter(el) {
      el.style.height= `${el.children[0].offsetHeight}px`
    },
    onLeave(el) {
      el.style.height = 0;
      el.style.padding = 0;
    },
    isChangePrice(item) {
      return ['+','-','%'].includes(item.category)
    },
    initDefaultShowListHeight() {
      const offsetHeight = this.$refs[`ordersItem-${this.isActive}`][0].offsetHeight
      this.$refs[`ordersItem-${this.isActive}`][0].style.height =`${offsetHeight}px`
    },
    onSubmit() {
      this.$emit('submit')
    },
    submitInvalid() {
      if((this.submitData.paymentMethod === 'Credit' && !this.submitData.expYear) 
      || (this.submitData.paymentMethod === 'Deposit' && this.currentMember.point < this.cartTotal)) {
        return true
      } else {
        return false
      }
    },
  }
}
</script>
<!-- section template -->
<template>
<div>
  <div :class="$style.infoBoxPrepaid">
    <h4 class="mb-4">訂單摘要</h4>
    <div
      :class="$style.ordersList"
    >
      <div
        class="ordersItem__item"
      >
        <div 
          class="ordersItem__title d-flex align-items-center justify-content-between isActive"
        >
          <div>
              <span class="text-primary fs-sm mr-3">{{cart.prepaid.title}}</span>
          </div>
          <div class="ordersItem__icon">
            <i class="fal fa-angle-right"></i>
          </div>
        </div>
          <transition
            name="slide" 
            @enter="onEnter"
            @leave="onLeave"
            @before-enter="onBeforeEnter"
          >
          <div
            :ref="`ordersItem-0`" 
            class="ordersItem__contentBox isActive"
          >
            <BaseList
              :data-list="billList"
              class="py-2"
              type="bill"
            />
          </div>
        </transition>
        <!-- <div class="ordersItem__total d-flex align-items-center justify-content-between">
          <span>小計</span>
          <span>{{ formatPrice(cart.prepaid.price) }}</span>
        </div> -->
      </div>
    </div>
    <hr >
    <div class="infoBoxDeposit__total d-flex align-items-center justify-content-between">
      <span>總計</span>
      <span :class="`${$globalIsDingBeauty ? 'text-secondary' : 'text-primary-dark'} fs-xl`">{{ formatPrice(cartTotal) }}</span>
    </div>
    <!-- <BaseList
      :data-list="billList"
      type="bill"
      class="mb-4"
    >
      <FormCoupon
        slot="coupon"
        v-model="data"
        class="mt-2"
        :cart="cart"
        :is-unpaid="isUnpaid"
      />
    </BaseList> -->
    <!--<BaseButton
      :disabled="invalid"
      class="isStylePrimary isRadius isFull d-none d-md-block"
      @click="onSubmit"
    >
      下一步：填寫寵物資訊
    </BaseButton>-->
    <!-- <BasePre>{{ couponDiscount }}</BasePre> -->
    <BaseButton
      v-if="!$globalIsDingBeauty"
      :disabled="invalid || submitInvalid()"
      class="isStylePrimary isFull d-none d-md-block isRadius mt-4"
      @click="onSubmit"
    >
      <div class="">
        <span>{{ formatSubmitText }}</span>
      </div>
    </BaseButton>
  </div>
  <BaseButton
      v-if="$globalIsDingBeauty"
      :disabled="invalid || submitInvalid()"
      class="isStylePrimary isFull d-none d-md-block"
      @click="onSubmit"
    >
      <div class="d-flex justify-content-between align-items-center pt-1 px-2">
        <span>{{ formatSubmitText }}</span>
        <span><i class="fontello fontello-arrow-right-helf fs-4xl"></i></span>
      </div>
    </BaseButton>
</div>
</template>
<!-- section style -->
<style lang="scss" module>
.infoBoxPrepaid {
  padding: 2.25rem 1.875rem;
  background: #FFF;
  box-shadow: 2px 8px 36px #1C2C5414;

  @include max-md {
    border-bottom: $color-gray-4 1px solid;
    border-radius: 0;
    box-shadow: none;
  }

  :global {
    .infoBoxPrepaid {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.125rem;
        font-weight: 600;
      }

      &__info {
        margin-bottom: 2rem;
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
      }
      &__total {
        padding: 0 0 1.25rem;
        font-size: 0.875rem;
        color: $color-gray-2;
      }
    }
  }
  .ordersList {
    :global {
      .ordersItem {
        &__item {
          padding: 0 1.25rem;
          background: rgba($color-primary, 10%);
          &:not(:last-child) {
            margin-bottom:  1rem;
          }
        }
        &__title {
          padding: 1.25rem 0;
          cursor: pointer;
          .ordersItem__icon {
            i {
              color: $color-gray-2;
              font-size: 1.5rem;
              transition: .3s;
            }
          }
          &.isActive {
            .ordersItem__icon {
              i {
                transform: rotate(90deg);
              }  
            }
          }
        }
        &__contentBox {
          overflow: hidden;
          transition: 0.3s;
          // will-change: height;

         
        }
        &__contentList {
          font-size: 0.875rem;
          padding: 0 0 1.25rem;
          color: $color-gray-2;
          @include list-unstyled();
        }
        &__contentItem {
          display: flex;
          justify-content: space-between;
          &:not(:last-child) {
            margin-bottom: 8px;
          }
        }
        &__contentPrice {
          flex-shrink: 0;
          margin-left: 1rem;
        }
        &__total {
          border-top: 1px solid $color-line;
          padding: 1.25rem 0;
          font-size: 0.875rem;
          color: $color-gray-2;
        }
      }
    }
  }
  :global {
    .slide-leave-active,
    .slide-enter-active {
      // transition: height 10s ease;
    }
    .slide-enter-from {
      // height: 0;
    }
    .slide-leave-to {
      height: 0;
      // height: 300px;
    }
  }
 
}
</style>
